import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';

import AdminLayout from '../../layouts/AdminLayout';

import Main from './main';

function index({ match }) {
  return (
    <AdminLayout>
      <Switch>
        <Redirect exact from={`${match.url}`} to={`${match.url}/main`} />
        <Route exact path={`${match.url}/main`} component={Main} />
      </Switch>
    </AdminLayout>
  );
}

const mapStateToProps = (state) => ({
  //
});

export default connect(mapStateToProps, {})(index);
